export default function NoTransportIcon() {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7746_364962)">
        <path
          d="M20.9091 8.75H18.3182V5.5H6.22727C5.27727 5.5 4.5 6.23125 4.5 7.125V16.0625H6.22727C6.22727 17.4113 7.38455 18.5 8.81818 18.5C10.2518 18.5 11.4091 17.4113 11.4091 16.0625H16.5909C16.5909 17.4113 17.7482 18.5 19.1818 18.5C20.6155 18.5 21.7727 17.4113 21.7727 16.0625H23.5V12L20.9091 8.75ZM8.81818 17.2812C8.10136 17.2812 7.52273 16.7369 7.52273 16.0625C7.52273 15.3881 8.10136 14.8438 8.81818 14.8438C9.535 14.8438 10.1136 15.3881 10.1136 16.0625C10.1136 16.7369 9.535 17.2812 8.81818 17.2812ZM20.4773 9.96875L22.17 12H18.3182V9.96875H20.4773ZM19.1818 17.2812C18.465 17.2812 17.8864 16.7369 17.8864 16.0625C17.8864 15.3881 18.465 14.8438 19.1818 14.8438C19.8986 14.8438 20.4773 15.3881 20.4773 16.0625C20.4773 16.7369 19.8986 17.2812 19.1818 17.2812Z"
          fill="#000000"
        />
      </g>
      <rect
        x="1.62782"
        y="15.9403"
        width="23.1083"
        height="2.8"
        transform="rotate(-30 1.62782 15.9403)"
        fill="#000000"
        stroke="white"
        strokeWidth="1.5"
      />
      <defs>
        <clipPath id="clip0_7746_364962">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
